<script setup lang="ts" name="TitleCaption">
defineProps<{
  truncate?: boolean;
  disabled?: boolean;
}>();
</script>

<template>
  <p
    class="text-body-2"
    :class="{
      truncate,
      'text-charcoal-6': !disabled,
      'text-charcoal-5': disabled,
    }"
  >
    <slot />
  </p>
</template>
